import React from 'react';
import { BarChart3, TrendingUp, Activity, MapPin } from 'lucide-react';

const Dashboard = () => {
  const stats = [
    {
      icon: Activity,
      label: 'Total Prints Today',
      value: '15,234',
      change: '+12.5%',
      color: 'yellow'
    },
    {
      icon: MapPin,
      label: 'Active Kiosks',
      value: '28',
      change: '+3 new',
      color: 'green'
    },
    {
      icon: TrendingUp,
      label: 'Today\'s Revenue',
      value: '₹45,678',
      change: '+23.5%',
      color: 'blue'
    },
    {
      icon: BarChart3,
      label: 'Weekly Growth',
      value: '23.5%',
      change: 'vs last week',
      color: 'purple'
    }
  ];

  const recentActivity = [
    { location: 'IIT Delhi - Library', prints: 342, time: '2 hours ago', status: 'active' },
    { location: 'DU North Campus', prints: 289, time: '3 hours ago', status: 'active' },
    { location: 'Tech Park Bangalore', prints: 456, time: '5 hours ago', status: 'active' },
    { location: 'Anna University', prints: 198, time: '6 hours ago', status: 'active' }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-yellow-500 font-semibold text-sm uppercase tracking-wide">Dashboard Preview</span>
          <h2 className="text-4xl lg:text-5xl font-bold mt-3 mb-6">
            Real-Time Analytics & Insights
          </h2>
          <p className="text-lg text-gray-300">
            Monitor your PRINTLEY kiosks with powerful analytics. Track usage, revenue, and performance in real-time.
          </p>
        </div>

        {/* Dashboard Mock */}
        <div className="max-w-6xl mx-auto">
          {/* Stats Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            {stats.map((stat, index) => (
              <div 
                key={index}
                className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-2xl p-6 hover:bg-gray-800 transition-colors duration-200"
              >
                <div className="flex items-center justify-between mb-4">
                  <div className="w-12 h-12 bg-yellow-500/10 rounded-xl flex items-center justify-center">
                    <stat.icon className="w-6 h-6 text-yellow-500" />
                  </div>
                  <span className="text-green-400 text-sm font-semibold">
                    {stat.change}
                  </span>
                </div>
                <p className="text-gray-400 text-sm mb-2">{stat.label}</p>
                <p className="text-3xl font-bold">{stat.value}</p>
              </div>
            ))}
          </div>

          {/* Main Dashboard Content */}
          <div className="grid lg:grid-cols-2 gap-8">
            {/* Activity Chart Placeholder */}
            <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-2xl p-8">
              <h3 className="text-xl font-bold mb-6 flex items-center">
                <BarChart3 className="w-6 h-6 text-yellow-500 mr-3" />
                Print Activity
              </h3>
              <div className="space-y-4">
                {/* Mock Chart Bars */}
                {[85, 92, 78, 95, 88, 90, 96].map((height, index) => (
                  <div key={index} className="flex items-center gap-4">
                    <span className="text-sm text-gray-400 w-8">
                      {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'][index]}
                    </span>
                    <div className="flex-1 bg-gray-700 rounded-full h-8 overflow-hidden">
                      <div 
                        className="bg-gradient-to-r from-yellow-500 to-yellow-600 h-full rounded-full flex items-center justify-end pr-3"
                        style={{ width: `${height}%` }}
                      >
                        <span className="text-xs font-semibold text-gray-900">
                          {Math.floor(height * 50)}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Recent Activity */}
            <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-2xl p-8">
              <h3 className="text-xl font-bold mb-6 flex items-center">
                <Activity className="w-6 h-6 text-yellow-500 mr-3" />
                Recent Activity
              </h3>
              <div className="space-y-4">
                {recentActivity.map((activity, index) => (
                  <div 
                    key={index}
                    className="flex items-center justify-between p-4 bg-gray-700/50 rounded-xl hover:bg-gray-700 transition-colors duration-200"
                  >
                    <div className="flex items-center gap-3">
                      <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                      <div>
                        <p className="font-semibold text-sm">{activity.location}</p>
                        <p className="text-xs text-gray-400">{activity.time}</p>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="font-bold text-yellow-500">{activity.prints}</p>
                      <p className="text-xs text-gray-400">prints</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Bottom Note */}
          <div className="mt-8 text-center bg-yellow-500/10 border border-yellow-500/20 rounded-2xl p-6">
            <p className="text-yellow-500 font-semibold">
              📊 This is a preview of the PRINTLEY dashboard. Partner with us to get full access!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dashboard;
